import styled, { keyframes } from 'styled-components'

const scroll = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
`

/* the flex track is laid out right-to-left under `dir="rtl"`, so it has to travel
   the other way for the marquee to loop instead of drifting off-screen */
const scrollRtl = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(50%); }
`

export const TrackWrapper = styled.div`
  overflow: hidden;
  width: calc(100% + 40px);
  padding: 24px 0;
  position: relative;
  inset-inline-start: -20px;
  max-width: fit-content;
  margin-inline: auto;
`

export const Track = styled.div`
  display: flex;
  gap: 8px;
  width: max-content;
  animation: ${({ theme }) => (theme.isRtl ? scrollRtl : scroll)} 30s linear infinite;

  &:hover {
    animation-play-state: paused;
  }
`

export const CardsPack = styled.div`
  display: flex;
  gap: 8px;
`

export const Card = styled.div`
  flex-shrink: 0;
  width: min(calc(100vw - 72px), 360px);
  padding: 14px 16px;
  background-color: #fdfbf6;
  border: 1px solid #fff;
  border-radius: 16px;
  box-shadow: 0 0 34px rgba(0, 0, 0, 0.1);
`

export const CardHeader = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
`

export const AvatarInfo = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  gap: 8px;
  align-items: flex-start;
`

export const Avatar = styled.div<{ $faceImg: string }>`
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 1px solid #e0dacb;
  background: #f9f2e2 url(${({ $faceImg }) => $faceImg}) center / cover no-repeat;
  overflow: hidden;
`

export const ReviewTitle = styled.p`
  margin: 0;
  font-weight: 500;
  font-size: 14px;
  color: #000;
  text-align: start;
`

export const Stars = styled.div`
  flex-shrink: 0;
  width: 80px;
  height: 14px;
  background-image: url(${'/assets/images/reviews/star.svg'});
  background-size: contain;
  background-repeat: space;
`

export const ReviewText = styled.p`
  margin: 8px 0 0;
  font-size: 12px;
  color: #000;
  text-align: start;
`

export const CardFooter = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: #000;
`

export const Location = styled.span`
  white-space: nowrap;
`
